import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { LAB } from "@/data/lab";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-navy text-white grain overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-24 pb-10">
        {/* Massive editorial mark */}
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-7">
            <p className="font-mono-tag text-cyan-brand/90">
              — Book a Test / Reach us
            </p>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] mt-6 tracking-tight">
              Precise diagnostics,<br />
              <em className="italic font-medium text-cyan-brand">calmly delivered.</em>
            </h2>
            <p className="mt-8 max-w-md text-white/70 leading-relaxed">
              Speak with our lab team directly. Reports, home collections
              and hospital infection-control queries are handled during
              working hours.
            </p>
          </div>

          <div className="col-span-12 md:col-span-5 md:pl-10">
            <div className="flex flex-col divide-y divide-white/10 border-y border-white/10">
              <a
                href={LAB.phoneHref}
                data-testid="footer-phone"
                className="group flex items-center justify-between py-6"
              >
                <span className="flex items-center gap-4">
                  <Phone className="h-4 w-4 text-cyan-brand" />
                  <span className="font-display text-2xl">{LAB.phone}</span>
                </span>
                <ArrowUpRight className="h-5 w-5 opacity-60 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500" />
              </a>
              <a
                href={LAB.phone2Href}
                data-testid="footer-phone2"
                className="group flex items-center justify-between py-6"
              >
                <span className="flex items-center gap-4">
                  <Phone className="h-4 w-4 text-cyan-brand" />
                  <span className="font-display text-2xl">{LAB.phone2}</span>
                </span>
                <ArrowUpRight className="h-5 w-5 opacity-60 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500" />
              </a>
              <a
                href={LAB.emailHref}
                data-testid="footer-email"
                className="group flex items-center justify-between py-6"
              >
                <span className="flex items-center gap-4">
                  <Mail className="h-4 w-4 text-cyan-brand" />
                  <span className="font-display text-lg md:text-xl truncate">
                    {LAB.email}
                  </span>
                </span>
                <ArrowUpRight className="h-5 w-5 opacity-60 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500" />
              </a>
              <a
                href={LAB.mapsUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-maps"
                className="group flex items-start justify-between py-6"
              >
                <span className="flex items-start gap-4">
                  <MapPin className="h-4 w-4 text-cyan-brand mt-1.5 shrink-0" />
                  <span className="text-white/85 leading-relaxed max-w-[26ch]">
                    {LAB.address}
                  </span>
                </span>
                <ArrowUpRight className="h-5 w-5 opacity-60 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500 shrink-0 ml-3" />
              </a>
            </div>
          </div>
        </div>

        {/* Colossal wordmark */}
        <div className="border-t border-white/10 pt-10">
          <div
            className="font-display italic text-[18vw] md:text-[13vw] leading-[0.85] tracking-tighter text-white/10 select-none"
            aria-hidden="true"
          >
            Lifeline
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-white/60 text-sm">
          <div className="flex items-center gap-4">
            <img
              src={LAB.images.logo}
              alt=""
              className="h-8 w-auto bg-white p-1 rounded-[2px]"
            />
            <span>© {new Date().getFullYear()} Lifeline Diagnostics · ISO Certified · Est. {LAB.established}</span>
          </div>
          <div className="flex items-center gap-6 font-mono-tag">
            <Link to="/" className="hover:text-white" data-testid="footer-nav-home">Home</Link>
            <Link to="/about" className="hover:text-white" data-testid="footer-nav-about">About</Link>
            <Link to="/tests" className="hover:text-white" data-testid="footer-nav-tests">Tests</Link>
            <Link to="/contact" className="hover:text-white" data-testid="footer-nav-contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
